module.exports = __webpack_public_path__ + "static/media/person_img.dc37eb5a.svg";